///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class GiftCardTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected giftCardTypes: GiftCardTypesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.giftCardTypes;
        }

        get leafCollection() {
            return this.giftCardTypes;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.giftCardTypes = new GiftCardTypesCollection(this.model[properties[0]], [], {
                criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.allSelectedLabel = 'LABEL_ALL_GIFT_CARDS';
            this.totalSelectedMessage = 'LABEL_TOTAL_GIFT_CARDS_SELECTED';
        }
    }
}